import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { Button } from "components/ui/button";
import type { ButtonProps } from "components/ui/button";

interface SubCategorySectionProps {
    children: ReactNode;
    viewAllHref: string;
    viewAllLabel: string;
    variant: "providers" | "ads";
}

const SubCategorySection: React.FC<SubCategorySectionProps> = ({ children, viewAllHref, viewAllLabel, variant }) => {
    const isAds = variant === "ads";
    const buttonPalette: ButtonProps["palette"] = isAds ? "indigo" : undefined;

    return (
        <section className={isAds ? "relative overflow-x-clip overflow-y-clip bg-background" : "bg-muted/50"}>
            {isAds && (
                <span
                    aria-hidden
                    className="pointer-events-none absolute -right-[1500px] top-[500px] h-[2000px] w-[2000px] rotate-[60deg] scale-150 bg-indigo-100/35"
                />
            )}

            <div className="relative mx-auto w-full max-w-[1400px] px-4 py-12 sm:px-10 lg:px-20 lg:py-14">
                {children}

                <div className="mt-10 flex justify-center sm:mt-12">
                    <Button asChild palette={buttonPalette} size="lg">
                        <Link to={viewAllHref}>
                            {viewAllLabel}
                            <ArrowRight className="size-4" aria-hidden />
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default SubCategorySection;
